<template>
    <section>
        <Form ref="editForm" class="margin-15" :model="formData" :label-width="150">
            <Row>
                <Col span="12">
                    <FormItem prop="shipType" label="发运方式" :rules="required">
                        <Select v-model="formData.shipType" @on-change="getReceiveInsuranceAmount(formData.shipType,formData.amount,formData.insuranceAmount,formData)">
                            <Option :value="1">LTL</Option>
                            <Option :value="2">FTL</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="company" label="卡车公司" :rules="required">
                        <Input v-model="formData.company"/>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="amount" label="金额" :rules="required">
                        <Input v-model="formData.amount" @on-blur="getReceiveInsuranceAmount(formData.shipType,formData.amount,formData.insuranceAmount,formData)"/>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="insuranceAmount" label="保险金额" >
                        <Input v-model="formData.insuranceAmount" @on-blur="getReceiveInsuranceAmount(formData.shipType,formData.amount,formData.insuranceAmount,formData)"/>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="referenceNo" label="参考号">
                        <Input v-model="formData.referenceNo" />
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="receiveAmount" label="应收金额" :rules="required">
                        <Input v-model="formData.receiveAmount" />
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="receiveInsuranceAmount" label="应收保险金额">
                        <Input v-model="formData.receiveInsuranceAmount" />
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div style="text-align: right;">
			<Button class="margin-right-20" type="primary" @click="submit">{{$t('global.common.save', { defaultValue: "保存" })}}</Button>
			<Button class="margin-right-20" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: "取消" })}}</Button>
		</div>
        <!-- <Spin size="large" fix :show="loading"></Spin> -->
    </section>
</template>

<script>
import { HttpTruckGetAmount, HttpTruckEnquiryEdit } from '@/service/bespeak';

export default{
    props:['orderid','initData'],
    data(){
        return {
            id: this.orderid,
            formData:JSON.parse(JSON.stringify(this.initData)) || {},
            loading:false,
            required: [{
                required: true,
                message: "该信息不能为空,请填写"
            }],
        }
    },
    created(){
    },
    methods:{
        getReceiveInsuranceAmount(shipType,amount,insuranceAmount,item){
            if(!shipType||!amount){
                return
            }
            HttpTruckGetAmount({
                truckReservationId:this.id,
                shipType,
                amount,
                insuranceAmount
            }).then(res=>{
                item.receiveAmount=res.data.receiveAmount;
                item.receiveInsuranceAmount=res.data.receiveInsuranceAmount
            },err=>{
                this.$VMessage.error(err.message);
            })
        },
        async submit() {
            const valid = await this.$refs.editForm.validate()
            if (!valid) return;
            this.loading = true;
            HttpTruckEnquiryEdit({
                id:this.id,
                ...this.formData,
            }).then(res=>{
                this.$Message.success(res.message)
                this.loading = false;
                this.cancel()
            },err=>{
                this.$Message.error(err.message)
                this.loading = false;
            })
        },
        cancel() {
            this.$emit('on-close')
        }
    }
}
</script>
